import type { PayloadAction } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import createSentryMiddleware from 'redux-sentry-middleware';

import { organizationGuidSel } from '@shared/duck/selectors/general.selectors';

import { loginDataSel, masqueradingSel } from '../modules/user';
import type { RootState } from './store';

const IGNORED_ACTIONS = [
  // Internal RTK actions
  'esbApi/subscriptions/internal_probeSubscription',
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default createSentryMiddleware(Sentry as unknown as any, {
  filterBreadcrumbActions(action: PayloadAction) {
    if (IGNORED_ACTIONS.includes(action.type)) return false;

    return true;
  },
  getUserContext: (state: RootState) => {
    const loginData = loginDataSel(state);
    if (loginData) {
      const organizationGuid = organizationGuidSel(state);
      const masquerading = masqueradingSel(state);
      const { account = {}, membership = {} } = loginData;
      const { username, userId } = account;
      const { memberId } = membership;
      const { personGuid } = loginData;

      return {
        username,
        userId,
        memberId,
        personGuid,
        organizationGuid,
        masquerading,
      };
    } else {
      return {};
    }
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  stateTransformer: ({ context }: any) => ({ ...context }),
  actionTransformer: (action: PayloadAction) => ({ type: action?.type }),
});
